import { call, put, takeLatest } from "redux-saga/effects";
import {
    fetchAdminCountFailure,
    fetchAdminCountSuccess,
    fetchStaffCountFailure,
    fetchStaffCountSuccess,
    getPatientCountFailure,
    getPatientCountSuccess,
} from "./dashboardAction";

import { getAdminCount, getStaffCount,getPatientCount } from "./dashboardEffect";
import {
    ADD_FETCH_ALL_COUNT_ADMINS_REQUEST,
    ADD_FETCH_ALL_COUNT_STAFF_REQUEST,
    GET_PATIENT_COUNT_REQUEST   
} from "./dashboardType";

function* fetchAdminCountSaga(action) {
  try {
    const response = yield call(getAdminCount,action.payload);
    yield put(fetchAdminCountSuccess(response.data));
  } catch (error) {
    yield put(fetchAdminCountFailure(error.message || "Failed to fetch admin count"));
  }
}

function* fetchStaffCountSaga(action) {
  try {
    const response = yield call(getStaffCount,action.payload);
    yield put(fetchStaffCountSuccess(response.data));
  } catch (error) {
    yield put(fetchStaffCountFailure(error.message || "Failed to fetch staff count"));
  }
}

function* getPatientCountSaga(action) {
  try {
    const response = yield call(getPatientCount, action.payload.number);
    yield put(getPatientCountSuccess(response.data));
  } catch (error) {
    yield put(getPatientCountFailure(error.message || "Failed to fetch patient count"));
  }
}

export function* dashboardSagas() {
  yield takeLatest(ADD_FETCH_ALL_COUNT_ADMINS_REQUEST, fetchAdminCountSaga);
  yield takeLatest(ADD_FETCH_ALL_COUNT_STAFF_REQUEST, fetchStaffCountSaga);
  yield takeLatest(GET_PATIENT_COUNT_REQUEST, getPatientCountSaga);
}